import {createContext, useContext} from "react";

export const initialShippingSetupValues = {
  shippingCostValue: 0,
  activeShippingCostIndex: -1,
  shippingSetupList: [],
};

const shippingSetupAction = "CHANGE_SHIPPING_SETUP_CONTEXT";

const ShippingSetupContext = createContext({});

export const useShippingSetupContext = () => useContext(ShippingSetupContext);

export const shippingSetupContextAction = (payload) => {
  return {
    type: shippingSetupAction,
    payload
  }
}

export const shippingSetupContextReducer = (state = initialShippingSetupValues, action) => {
  switch (action.type) {
    case shippingSetupAction:
      return {...state, ...action.payload};
    default:
      return state
  }
}

export default ShippingSetupContext;
